<template>
  <div v-if="profile.nickname" id="user_card">

    <Carousel :value="images" :numVisible="1" :numScroll="1" orientation="horizontal" verticalViewPortHeight="268px"
      :showNavigators="false" :showIndicators="true" :circular="true" id="user-photo-galery">
      <template #item="slotProps">
        <Image :src="getUrl(slotProps.data)" alt="Image" width="100%" preview />
        <img :src="getUrl(slotProps.data)" alt="Image" width="100%" class="bg-image" />
      </template>
    </Carousel>
    <div class="user-header">
      <Avatar :label="profile.nickname.charAt(0).toUpperCase()"
        style="background-color:#2196F3; color: #ffffff; margin-left:10px; margin-right: 10px;" shape="circle"
        v-if="!profile.avatar" />
      <Avatar :image="$utils.getAvatar(profile.avatar)"
        style="background-color:#2196F3; color: #ffffff; margin-left:10px; margin-right: 10px;" shape="circle" v-else />
      <div class="user-title">
        <h2 class="m-0">{{ profile.nickname }}</h2>
      </div>
      <span class="age_gender" :class="$utils.getClass(profile.gender)" v-html="$utils.getAgeSex(profile)"></span>
    </div>

    <div v-if="looking_for" class="looking-for" :class="looking_for.style">
      <div class="looking-for-icon"><span class="emoji">{{ looking_for.emoji }}</span>
        <div class="looking-for-text">
          {{ $t('profile_card.lookingFor') }}<br>
          <span class="looking-for-name">{{ looking_for.name }}</span>
        </div>
      </div>
    </div>
    <div class="user-details">

      <div  class="profile-extra-info">
        <h2 v-if="profile.about">{{ $t('profile_card.about') }}</h2>
        <div v-html="profile.about" class="mb-3"></div>

        <p v-if="profile.location"><i class="pi pi-map-marker"></i> {{ profile.location }}</p>
        <p v-if="profile.zodiac"><span class="material-symbols-outlined">flare</span> {{ getZodic(profile.zodiac) }}</p>
        <p v-if="profile.education"><span class="material-symbols-outlined">school</span>
          {{ getEducation(profile.education) }} </p>

      </div>
      <div v-if="profile.hobbies && profile.hobbies.length > 0" class="profile-extra-info">
        <h2 class="mb-3">{{ $t('profile_card.hobbies') }}</h2>
        <Chip v-for="hobby in profile.hobbies" :key="hobby" :label="hobby" class="mr-1" />
      </div>

      <div v-if="profile.langs && profile.langs.length > 0" class="profile-extra-info">
        <h2 class="mb-3">{{ $t('profile_card.langs') }}</h2>
        <Chip v-for="lang in langSelected" :key="lang.id" :label="lang.name" class="mr-1" />
      </div>

    </div>


  </div>
</template>

<script>
export default {
  props: ['profile'],
  data() {
    return {
      looking_for: null,
      images: [],
    };
  },
  mounted() {
    this.looking_for = this.getLookingFor(this.profile.looking_for);
    if ((!this.profile.profile_images || this.profile.profile_images.length == 0) && this.profile.avatar) {
      this.images =
        [
          {
            "id": 0,
            "user_id": this.profile.user_id,
            "image_url": this.profile.avatar,
            "sort_number": 0,
          }
        ]
    } else {
      this.images = this.profile.profile_images;
    }

    console.log(this.profile );
  },
  watch: {
    'profile'(newValue) {
      console.log(newValue);
    },
    'profile.looking_for'(newValue) {
      this.looking_for = this.getLookingFor(newValue);
    },
    'profile.profile_images'(newValue) {
      if (!newValue || newValue.length == 0) {
        this.images =
          [
            {
              "id": 0,
              "user_id": this.profile.user_id,
              "image_url": this.profile.avatar,
              "sort_number": 0,
            }
          ]
      } else {
        this.images = (newValue);
      }
    }
  },
  computed: {
    langSelected() {
      var langs = this.$tm('langs');
      const filtered = langs.filter(lang => this.profile.langs.includes(lang.id));
      return filtered
    }
  },
  methods: {
    addNote() {
      // Not ekleme işlemi
    },

    getUrl(data) {
      if (!data)
        return null;
      if (data.url)
        return this.$socket_url + '/profiles/' + this.profile.user_id + '/' + data.url;
      if (data.image_url) {
        if (data.image_url.startsWith('http://') || data.image_url.startsWith('https://'))
          return data.image_url;
        else
          return this.$socket_url + '/profiles/' + this.profile.user_id + '/' + data.image_url;
      }
      if (data.file)
        return URL.createObjectURL(data.file);
      return null;
    },
    getZodic(zodiac) {
      var zodiacs = this.$tm('zodiac')
      var finded = zodiacs.find(z => z.id == zodiac);
      if (finded)
        return finded.name;
      else
        return '-';
    },
    getEducation(education) {
      var educations = this.$tm('educations')
      var finded = educations.find(e => e.id == education);
      if (finded)
        return finded.name;
      else
        return '-';
    },
    getLookingFor(looking_for) {
      var looking_fors = this.$tm('lookingFor')
      var finded = looking_fors.find(l => l.id == looking_for);
      if (finded)
        return finded;
      else
        return null;
    },
    updateGalery(newImages) {
      const filtered = newImages.filter(image => (image.url || image.file));
      this.images = [...filtered];
    }
  }
}
</script>

<style scoped>
#user_card {
  min-height: 100%;
}

.user-header {
  display: flex;
  align-items: center;
  margin-top: -5px;
  position: relative;
}

.avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-right: 10px;
}

.status-text {
  color: green;
}

.user-details p {
  margin: 0;
  display: flex;
  align-items: center;
  font-size: 16px;
}


span.emoji {
  font-size: 38px;
}

.p-galleria {
  border: none;
  border-radius: 0;
}

.user-header {
  padding-bottom: 10px;
  border-bottom: 1px solid var(--p-neutral-200);
  padding-top: 10px;
}

.p-image-preview {
  position: relative;
  display: inline-flex;
  line-height: 0;
  width: 100%;
}

.p-avatar-circle {
  margin-top: 5px;
  margin-bottom: auto;
}

.user-title p {
  margin: 0;
  font-size: 14px;
  line-height: 18px;
  font-weight: 500;
  display: flex;
  align-items: center;
}

span.material-symbols-outlined {
  font-size: 14px;
  margin-right: 5px;
}

.pi {
  font-size: 12px;
  margin-right: 5px;

}


.user-details h2 {
  margin: 0;
}

.profile-extra-info {
  padding: 8px 15px;
  padding-left:0;
  border-bottom: 1px solid var(--p-neutral-200);
}

.looking-for {
  padding: 15px 0;
  border-bottom: 1px solid var(--p-neutral-200);
}

.looking-for div {
  margin: 0;
  padding: 6px 8px;
  background: aqua;
  border-radius: 10px;
  width: fit-content;
  margin: auto;
}

span.looking-for-name {
  font-size: 21px;
}

.looking-for-icon {
  display: flex;
}

.looking-for.purple div {
  background: rgb(32, 0, 48);
  color: rgb(186, 82, 245);
}

.looking-for.pink div {
  background: rgb(47, 7, 1);
  color: #f13b2d;
}

.looking-for.yellow div {
  background: rgb(45, 16, 0);
  color: rgb(205, 113, 5);
}

.looking-for.green div {
  background: rgb(0, 25, 22);
  color: rgb(18, 158, 104);
}

.looking-for.turquoise div {
  background: rgb(3, 22, 25);
  color: rgb(25, 154, 159);
}

.looking-for.blue div {
  background: rgb(0, 19, 46);
  color: rgb(23, 134, 255);
}

.age_gender {
  top: 21px;
}
</style>